import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { C, btnPrimary, btnGhost, softShadow } from "../lib/theme";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
        if (attempts >= 8) { setStatus("failed"); return; }
        setTimeout(() => setAttempts((a) => a + 1), 2000);
      } catch {
        if (attempts >= 8) setStatus("failed");
        else setTimeout(() => setAttempts((a) => a + 1), 2000);
      }
    };
    poll();
    return () => { active = false; };
  }, [sessionId, attempts]);

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-white rounded-3xl p-10 max-w-md w-full text-center" style={softShadow} data-testid="payment-success">
        {status === "checking" && (
          <>
            <Loader2 className="w-14 h-14 mx-auto mb-5 animate-spin" style={{ color: C.CORAL }} />
            <h1 className="font-display text-3xl font-extrabold mb-2" style={{ color: C.INK }}>Verifica pagamento…</h1>
            <p style={{ color: "#6b665d" }}>Attendi un istante mentre confermiamo la tua caparra.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto mb-5" style={{ color: C.GREEN }} />
            <h1 className="font-display text-3xl font-extrabold mb-2" style={{ color: C.INK }}>Prenotazione confermata!</h1>
            <p className="mb-8" style={{ color: "#6b665d" }}>La caparra è stata ricevuta. Il tuo tavolo è assicurato.</p>
            <Link to="/" data-testid="success-home" className={`${btnPrimary} inline-flex`}>Torna alla home</Link>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle className="w-16 h-16 mx-auto mb-5 text-red-500" />
            <h1 className="font-display text-3xl font-extrabold mb-2" style={{ color: C.INK }}>Pagamento non confermato</h1>
            <p className="mb-8" style={{ color: "#6b665d" }}>Non siamo riusciti a confermare il pagamento. Riprova dal link ricevuto via email.</p>
            <Link to="/" className={`${btnGhost} inline-flex`}>Torna alla home</Link>
          </>
        )}
      </motion.div>
    </div>
  );
}
